import React from "react";
import { HeaderWrapper } from "./HeaderStyle";
import MarktineLogo from "./MarktineLogo.png"



const Header = () => {
    return (
        <HeaderWrapper>
            <img style={{ width: "200px", padding: "20px" }} src={MarktineLogo}></img>
        </HeaderWrapper>
    )

};
export default Header;